import React from 'react';

import IconType from '../../../types/Icon';

const TableBooking: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M18 12C14.6981 12 12 14.6981 12 18C12 21.3019 14.6981 24 18 24C21.3019 24 24 21.3019 24 18C24 14.6981 21.3019 12 18 12ZM18 14C20.221 14 22 15.779 22 18C22 20.221 20.221 22 18 22C15.779 22 14 20.221 14 18C14 15.779 15.779 14 18 14ZM18.4277 15.1172L16.8281 18.1387L18.9258 20.2363L19.9863 19.1758L18.6719 17.8613L19.7539 15.8184L18.4277 15.1172Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 8V6H22V8H20.3145L20.6921 10.4642C19.8508 10.1637 18.9445 10 18 10H18.5957L18.2949 8H5.65625L5.36523 10H18C15.9711 10 14.1186 10.7553 12.7084 12H5.07422L4.05273 19H2L3.63867 8H2Z"
				fill={color}
			/>
		</svg>
	);
};

export default TableBooking;
